var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2125_30432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9955 17.9992V17.9984H18V11.3969C18 8.16744 17.3047 5.67969 13.5292 5.67969C11.7142 5.67969 10.4962 6.67569 9.99896 7.61994H9.94646V5.98119H6.3667V17.9984H10.0942V12.0479C10.0942 10.4812 10.3912 8.96619 12.3315 8.96619C14.2432 8.96619 14.2717 10.7542 14.2717 12.1484V17.9992H17.9955Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.296875 5.98438H4.02888V18.0016H0.296875V5.98438Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1615 0C0.96825 0 0 0.96825 0 2.1615C0 3.35475 0.96825 4.34325 2.1615 4.34325C3.35475 4.34325 4.323 3.35475 4.323 2.1615C4.32225 0.96825 3.354 0 2.1615 0V0Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2125_30432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.fd2be602e9a79e4b838be95dc3939056.svg";
export { ForwardRef as ReactComponent };